import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Package, ArrowRight, Snowflake } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { SEO } from '../components/SEO';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col" data-testid="notfound-page">
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." />
      <Navbar />

      <main className="flex-1 flex items-center justify-center section-padding py-28">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-[#0F172A] mb-8 relative">
            <Snowflake className="h-9 w-9 text-[#CE8946]" />
          </div>

          <p className="text-sm font-semibold uppercase tracking-[0.25em] text-[#CE8946] mb-3">Error 404</p>
          <h1 className="text-5xl sm:text-6xl font-bold text-[#0a0203] tracking-tight">This page went cold.</h1>
          <p className="text-base text-gray-500 mt-5 max-w-lg mx-auto leading-relaxed">
            The page you're looking for may have been moved, renamed, or never existed. Let's get you back to something useful.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-9">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-[#003456] text-white font-semibold px-6 py-3 rounded-md hover:bg-[#002B47] transition-colors"
              data-testid="notfound-home-btn"
            >
              <Home className="h-4 w-4" /> Back to home
            </Link>
            <Link
              to="/products"
              className="inline-flex items-center gap-2 border border-slate-300 text-[#0a0203] font-semibold px-6 py-3 rounded-md hover:bg-white transition-colors"
              data-testid="notfound-products-btn"
            >
              <Package className="h-4 w-4" /> Browse freeze dryers
            </Link>
          </div>

          <div className="mt-12 pt-8 border-t border-slate-200">
            <p className="text-sm text-gray-400 mb-4">Popular destinations</p>
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm">
              <Link to="/capacity-calculator" className="text-[#003456] font-medium hover:underline inline-flex items-center gap-1">Capacity calculator <ArrowRight className="h-3.5 w-3.5" /></Link>
              <Link to="/resources" className="text-[#003456] font-medium hover:underline inline-flex items-center gap-1">Resources <ArrowRight className="h-3.5 w-3.5" /></Link>
              <Link to="/contact" className="text-[#003456] font-medium hover:underline inline-flex items-center gap-1">Contact us <ArrowRight className="h-3.5 w-3.5" /></Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
